// currencyConfig.js
// Central currency setting for the application

// ISO code for Central African CFA franc
export const CURRENCY_CODE = 'XAF';
// FCFA has no decimal places
export const MIN_FRACTION_DIGITS = 0;
